import { render, staticRenderFns } from "./ImageComponent.vue?vue&type=template&id=2f8fd49e"
import script from "./ImageComponent.vue?vue&type=script&lang=ts"
export * from "./ImageComponent.vue?vue&type=script&lang=ts"
import style0 from "./ImageComponent.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports